<!-- ================登录-美育五馆====================-->
<template>
    <div class="full-screen-container login-container">
        <simple-head />
        <div class="login-middle-container">
            <div class="login-box-container">
                <div class="login-tab-container">
                    <div :class="loginTab==='2'?'login-tab1-active':'login-tab1'" @click="changeTab('2')">个人登录</div>
                    <div class="login-tab2"></div>
                    <div :class="loginTab==='1'?'login-tab1-active':'login-tab1'" @click="changeTab('1')">机构登录</div>
                </div>
                <!-- 个人登录-->
                <div class="login-form-container" v-if="loginTab==='2'">
                    <el-form ref="userLoginFormRef" :model="userLoginForm" :rules="userLoginRules">
                        <el-form-item prop="username">
                            <el-input style="height: 40px" type="text" v-model="userLoginForm.username" placeholder="请输入登录账号" prefix-icon="Iphone"></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input style="height: 40px" type="password" v-model="userLoginForm.password" placeholder="请输入登录密码" prefix-icon="Lock"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="submit-login-btn" @click="submitUserLogin">登录</div>
                </div>
                <!-- 机构登录-->
                <div class="login-form-container" v-if="loginTab==='1'">
                    <el-form ref="orgLoginFormRef" :model="orgLoginForm" :rules="orgLoginRules">
                        <el-form-item prop="username">
                            <el-input style="height: 40px" type="text" v-model="orgLoginForm.username" placeholder="请输入登录账号" prefix-icon="Iphone"></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input style="height: 40px" type="password" v-model="orgLoginForm.password" placeholder="请输入登录密码" prefix-icon="Lock"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="submit-login-btn" @click="submitOrgUserLogin">登录</div>
                </div>
            </div>
        </div>
        <div class="login-bottom-container">
            © 2026 博雅美育浸润版权所有 | 今日日期：2026年06月08日
        </div>
    </div>
</template>
<script>
import {userLogin,orgUserLogin} from "@/api/user/user"
import simpleHead from "@/components/common/simpleHead.vue";
export default {
    components: {simpleHead},
    name: "userLogin",
    data() {
        return {
            loginTab:'2',
            // 个人登录
            userLoginForm: {
                username: "",
                password: "",
                code: "",
            },
            userLoginRules: {
                username: [{ required: true, message: "请输入登录账号", trigger: "blur" },],
                password: [{ required: true, message: "请输入登录密码", trigger: "blur" }],
            },
            // 机构登录
            orgLoginForm: {
                username: "",
                password: "",
                code: "",
            },
            orgLoginRules: {
                username: [{ required: true, message: "请输入登录账号", trigger: "blur" },],
                password: [{ required: true, message: "请输入登录密码", trigger: "blur" }],
            },
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {},
    methods: {
        changeTab(tab){
            this.loginTab = tab;
        },
        // 个人登录
        submitUserLogin(){
            this.$refs["userLoginFormRef"].validate(valid => {
                if (valid) {
                    userLogin(this.userLoginForm).then(res => {
                        if (res.data.code === 1) {
                            const info = res.data.data
                            this.$storage.set("userInfo", JSON.stringify(info.userInfo));
                            this.$storage.set("token", info.token);
                            this.$storage.set("role", info.role+'');
                            this.$storage.set("isLogin", true);
                            this.$router.push("/museum/home")
                            
                        }else {
                            this.$message.error(res.data.msg)
                        }
                    })
                }
            })
        },
        submitOrgUserLogin(){
            this.$refs["orgLoginFormRef"].validate(valid => {
                if (valid) {
                    orgUserLogin(this.orgLoginForm).then(res => {
                        if (res.data.code === 1) {
                            const info = res.data.data
                            this.$storage.set("userInfo", JSON.stringify(info.userInfo));
                            this.$storage.set("token", info.token);
                            this.$storage.set("role", info.role+'');
                            this.$storage.set("isLogin", true);
                            this.$router.push("/overview")
                        }else {
                            this.$message.error(res.data.msg)
                        }
                    })
                }
            })
        }
    },
}
</script>
<style>
.login-container{
    background-color: #f0eff2;
}
.login-middle-container{
    width: 100%;
    min-height: calc(100vh - 150px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
}
.login-box-container{
    width: 90%;
    max-width: 420px;
    height: auto;
    padding: 25px 30px 30px 30px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 18px;
}
.login-tab-container{
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    display: flex;
}
.login-tab1{
    flex: 1;
    height: 40px;
    letter-spacing: 3px;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    cursor: pointer;
}
.login-tab1-active{
    flex: 1;
    height: 40px;
    letter-spacing: 3px;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    color: #b22222;
    font-weight: bold;
    cursor: pointer;
}
.login-tab2{
    width: 1px;
    height: 20px;
    background-color: #e5e8ec;
    margin-top: 10px;
    flex-shrink: 0;
}
.submit-login-btn{
    padding: 0 10px 0 10px;
    height: 40px;
    text-align: center;
    color: #fff;
    background: #b22222;
    cursor: pointer;
    border-radius: 4px;
    line-height: 40px;
    font-size: 15px;
    font-family: sans-serif;
    font-weight: bold;
    letter-spacing: 10px;
}
.submit-login-btn:hover{
    background: #c14e4e;
}
.login-bottom-container{
    width: 100%;
    min-height: 60px;
    text-align: center;
    font-size: 13px;
    color: #9ca3af;
    font-family: sans-serif;
    padding: 10px 20px;
    box-sizing: border-box;
}
@media (max-width: 1024px) {
    .login-box-container { padding: 20px; }
    .login-tab1, .login-tab1-active { font-size: 16px; letter-spacing: 2px; }
}
</style>